import { useFeature } from '@billda/features-ui';
import type { NavigationItem } from '../components/layout/navigationItems';

/** Returns whether a nav item should be visible based on permission + feature flag. */
export function useNavItemVisible(
  item: NavigationItem,
  permissions: string[]
): boolean {
  const featureEnabled = useFeature(item.featureFlag || '');

  if (item.featureFlag && !featureEnabled) return false;
  return item.permission ? permissions.includes(item.permission) : true;
}
